import { Injectable } from "@angular/core";
import { Observable } from "rxjs";

@Injectable()
export class ProgressMeasurementService {
    private message: string = "Please Wait";
    private isSpinnerVisible: boolean = false;
    private hasCancelButton: boolean = false;
    private promise: Promise<any>;
    private resolve: (value: string) => void;

    displayMessage(value: string, hasCancelButton: boolean = false) {
        this.isSpinnerVisible = true;
        this.message = value;
        this.hasCancelButton = hasCancelButton;

        if (hasCancelButton) {
            this.promise = new Promise<any>((resolve, reject) => {
                this.resolve = resolve;
            });
        }

        return this.promise;
    }

    close() {
        this.isSpinnerVisible = false;
    }

    open() {
        this.isSpinnerVisible = true;
    }

    isOpen(): boolean {
        return this.isSpinnerVisible;
    }

    showCancelButton(): boolean {
        return this.hasCancelButton;
    }

    cancel() {
        this.resolve(null);
    }
}
